<template>
  <!-- 薪酬查看  -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="100px">
          <el-row :gutter="2" style="width: 100%;">
            <el-col :span="6">
              <el-form-item label="销售姓名:">
                <!-- <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input> -->
                <el-select v-model="formState.teacherName" style="width:100%;" placeholder="请选择销售">
                    <el-option v-for="ele in lePersList1" :key="ele.saleId" :label="ele.saleName" :value="ele.saleId" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="状态:" prop="jobName">
                <el-select v-model="formState.basicClassNum" style="width:100%;" placeholder="请选择状态">
                    <el-option v-for="ele in lePersList" :key="ele.value" :label="ele.name" :value="ele.value" ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="5">
              <el-form-item label="年:">
                <el-date-picker v-model="formState.salaryYear" type="year" value-format="yyyy" placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="月:" class="month_selection_box">
                <el-date-picker v-model="formState.salaryMonth" type="month" format="M月" value-format="MM"
                  popper-class="picker_month_select" placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
            </el-col>
           
          </el-row>

          <div style="width: 100%;text-align: end;">
            <el-form-item>
                <!-- <el-button @click="countBottom" icon="el-icon-thumb" size="small" class="btns">一键下发</el-button> -->
                <!-- <el-button @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button> -->
                <el-button @click="seachClear" class="btns" size="small" icon="el-icon-close">清除</el-button>
                <el-button type="primary" @click="seachRest" size="small" class="btns" icon="el-icon-search">搜索</el-button>
                <!-- <el-button type="primary" @click="seachRest1" size="small" class="btns" icon="el-icon-search">导出</el-button> -->
            </el-form-item>
          </div>

        </el-form>

        <el-table  ref="salaryTable" :summary-cell-style="{ 'text-align': 'center' }"  show-summary :summary-method="getSummaries"  :span-method="tableSpanMethod" style="margin-top: 20px;width: 100%; " height="800" :data="salaryList"  border :highlight-current-row="true" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
         
          <!-- <el-table-column prop="state" show-overflow-tooltip  label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 1">已确认</span>
              <span v-else>未确认</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="settlementMonth" show-overflow-tooltip  label="年月" width="100"></el-table-column>
          <el-table-column prop="salesName" show-overflow-tooltip  label="销售姓名" width="100"></el-table-column>
          <el-table-column prop="monthSalary"  show-overflow-tooltip label="底薪" width="100"></el-table-column>
          <el-table-column prop="performance"  show-overflow-tooltip label="绩效" width="100"></el-table-column>
          <el-table-column prop="performanceAmount"  show-overflow-tooltip label="业绩" width="100"></el-table-column>
          <el-table-column prop="monthRefund"  show-overflow-tooltip label="退费" width="100"></el-table-column>
          <el-table-column prop="validAmount"  show-overflow-tooltip label="实际提成业绩" width="160">

            <template slot="header">
                 <span>实际提成业绩</span>
                 <el-tooltip popper-class="tooltip" placement="top">
                   <i class="el-icon-question" style="font-size:17px; color: #009bff;"></i>
                    <div slot="content">
                      <div style="margin-bottom: 10px;">实际提成业绩计算方式：</div>
                      <div> 当月业绩 - 未达到五节课的客资 - 未结课定金客资</div>
                   </div>
                 </el-tooltip>
             </template>

          </el-table-column>
          <el-table-column prop="commissionCoefficient"  show-overflow-tooltip label="提成系数" width="600"></el-table-column>
          <el-table-column prop="commission"  show-overflow-tooltip label="业绩提成" width="100"></el-table-column>

          <el-table-column prop="refundCommission"  show-overflow-tooltip label="退费提成" width="100"></el-table-column>
          <el-table-column prop="actualCommission"  show-overflow-tooltip label="实际提成" width="100"></el-table-column>

          <el-table-column prop="notReachAmount"  show-overflow-tooltip label="未达标业绩" width="100"></el-table-column>
          <el-table-column prop="deduction"  show-overflow-tooltip label="扣款" width="100"></el-table-column>
          <el-table-column prop="reward"  show-overflow-tooltip label="奖励" width="100"></el-table-column>
          <el-table-column prop="subsidy"  show-overflow-tooltip label="补助" width="100"></el-table-column>
          <el-table-column prop="socialSecurity"  show-overflow-tooltip label="社保" width="100"></el-table-column>
          <el-table-column prop="payableWages" show-overflow-tooltip label="应发工资" width="150">
            <template slot="header">
                 <span>应发工资</span>
                 <el-tooltip popper-class="tooltip" placement="top">
                   <i class="el-icon-question" style="font-size:17px; color: #009bff;"></i>
                    <div slot="content">
                      <div style="margin-bottom: 10px;">应发工资计算方式：</div>
                      <div> 底薪 + 有效提成 + 绩效 + 奖励 + 补助 </div>
                   </div>
                 </el-tooltip>
             </template>
          </el-table-column>

          <el-table-column prop="actualWages" show-overflow-tooltip label="实发工资" width="150">
             <template slot="header">
                 <span>实发工资</span>
                 <el-tooltip popper-class="tooltip" placement="top">
                   <i class="el-icon-question" style="font-size:17px; color: #009bff;"></i>
                    <div slot="content">
                      <div style="margin-bottom: 10px;">实发工资计算方式：</div>
                      <div> 底薪 + 有效提成 + 绩效 + 奖励 + 补助 - 总扣款 - 社保 </div>
                   </div>
                 </el-tooltip>
             </template>
          </el-table-column>

          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="editInfo1(scope.row)" type="text">详情</el-button>
              <!-- <el-button @click="editInfo1Coot(scope.row)" type="text">重新计算</el-button> -->
            </template>
          </el-table-column>
        </el-table>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="formState.pageNum" :page-size="formState.pageSize" layout="prev, pager, next,sizes, jumper"
          :total="totalNum">
        </el-pagination>
      </el-card>
      <salary-dialog ref="salaryMoudel" v-if="isShowDialog" :childTeacherId="parentTeacherId" :editOrview="editOrview"
        @isShowBtn="isShowBtn"></salary-dialog>

    </div>



    <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
        <!-- <CourseSalesStatisticsDetails :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails> -->

        <SalaryTypeDetails  stringType="线上销售薪酬" v-if="ShowCourseSalesStatisticsDetails" :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></SalaryTypeDetails>
    </el-card>



  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import salaryDialog from "./salaryEdit.vue"
import CourseSalesStatisticsDetails from "./CourseSalesStatisticsDetails.vue"
import SalaryTypeDetails from "./SalaryTypeDetails.vue"
import axios from "axios";
import { getListSalarys,getgetListCount, getListSalaryss } from "@/api/salaryapi"


 // 获取当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始

    // 补零函数
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    // 当前月第一天
    const firstDay = `${year}-${pad(month)}-01`;
    // 当前月最后一天
    const lastDay = new Date(year, month, 0).getDate();
    const currentDay = `${year}-${pad(month)}-${pad(lastDay)}`;

export default {
  components: {
    salaryDialog,
    CourseSalesStatisticsDetails,
    SalaryTypeDetails,
  },
  data () {
    return {
      isShowDialog: false,
      editOrview: true,
      formState: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      },
      totalNum: 0,
      salaryList: [],
      parentTeacherId: "",
      ShowCourseSalesStatisticsDetails:false,
      TimeList:[ firstDay, currentDay ],
      DetailsRow:{},

      lePersList: [
        // { name: "在职", value: 1 },
        // { name: "离职", value: 2 },
        // { name: "请假", value: 3 },
        // { name: "休假", value: 4 },


        { name: "未确认", value: 0 },
        { name: "已确认", value: 1 },
        // { name: "复核中", value: 3 },
      ],

      lePersList1:[],

      summaryData: {
        actualWages: 0, 
        performance: 0, 
        monthSalary:0,
        payableWages:0,
        commission:0,
        subsidy:0,
        socialSecurity:0,
        monthRefund:0,
        reward:0,
        validAmount:0,
        deduction:0,
        performanceAmount:0,
        notReachAmount:0,
        refundCommission:0,
        actualCommission:0, 
      },

    }
  },
  created () {
    this.getList();
  },

  mounted () {
    axios.get(`${apiBaseUrl}/onlineSales/getOnlineSales`,{ headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }) .then((res) => {
        if (res.data.code == 200) {
           this.lePersList1 = res.data.data
        }else{
          this.lePersList1 = []
        }
      }).catch((error) => {
        this.lePersList1 = []
        console.error(error);
      });

    setTimeout(() => {
      this.$nextTick(() => {
         this.getList();
      });
    }, 0);
  },
  methods: {

     // 合计行内容
    getSummaries({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          // 前3列不展示
          if (index === 1) {
            sums[index] = '汇总';
          } 
          else if (column.property && this.summaryData[column.property] !== undefined) {
            sums[index] = this.summaryData[column.property];
          } else if (data.length === 0 && index >= 2) {
            // 没有数据时也展示“总计：”
            sums[index] = '';
          } else {
            sums[index] = '';
          }
        });
        return sums;
    },
    // 合并前3列
    tableSpanMethod({ rowIndex, columnIndex }) {
      // 最后一行（合计行）合并前3列
      if (rowIndex === this.salaryList.length && columnIndex === 0) {
        return [1, 4]; // 合并1行3列
      }
      if (rowIndex === this.salaryList.length && (columnIndex === 1 || columnIndex === 2)) {
        return [0, 0]; // 被合并的单元格
      }
    },



    handleEmitButs  (event) {
        this.ShowCourseSalesStatisticsDetails = event
    },

    count () {
      let data = {
        salaryYear: this.formState.salaryYear,
        salaryMonth: this.formState.salaryMonth
      }
      axios
        .post(`${apiBaseUrl}/salary/calculate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.getList()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getList () {
      let data = {
        pageNo: this.formState.pageNum,
        pageSize: this.formState.pageSize,
        salesId: this.formState.teacherName ? this.formState.teacherName : '',
        state: this.formState.basicClassNum ? this.formState.basicClassNum : '',
        yearStr: this.formState.salaryYear ? this.formState.salaryYear : '',
        monthStr: this.formState.salaryMonth ? this.formState.salaryMonth : '',
      } 

      getListSalarys(data).then((res) => {
        if (res.code == 200) {
            this.salaryList = res.data.records
            this.totalNum = res.data.total
            // this.formState.pageNum = res.data.current
            this.$message.success(res.message)
        } else {
          this.salaryList = []
          this.totalNum = 0
          this.$message.error(res.message)
        }
       
      }).catch((error) => {
        console.error(error);
         this.salaryList = []
         this.totalNum = 0
         this.$message.error(error)
      });



      getListSalaryss(data).then((res) => {
        if (res.code == 200) {
          this.summaryData = {
            actualWages: res.data.actualSalarySum,
            performance: res.data.performanceSum,
            monthSalary: res.data.salarySum,
            payableWages: res.data.totalSalarySum,
            commission: res.data.commissionSum,
            subsidy: res.data.subsidySum,
            socialSecurity: res.data.socialSecuritySum,
            monthRefund: res.data.refundSum,
            reward: res.data.rewardSum,
            validAmount: res.data.amountSum,
            deduction: res.data.deductionSum,
            performanceAmount: res.data.performanceAmountSum, 
            notReachAmount: res.data.notReachAmountSum,
            refundCommission: res.data.refundCommissionSum,
            actualCommission: res.data.actualCommissionSum, 
          }; 
        } else {
          this.summaryData = {
              actualWages: 0, 
              performance: 0, 
              monthSalary:0,
              payableWages:0,
              commission:0,
              subsidy:0,
              socialSecurity:0,
              monthRefund:0,
              reward:0,
              validAmount:0,
              deduction:0,
              performanceAmount:0,
              notReachAmount:0,
              refundCommission:0,
              actualCommission:0, 
          };
        }

         this.$nextTick(() => {
            if (this.$refs.salaryTable) {
              this.$refs.salaryTable.doLayout();
            }
         });

      }).catch((error) => {
        this.summaryData = {
            actualWages: 0, 
            performance: 0, 
            monthSalary:0,
            payableWages:0,
            commission:0,
            subsidy:0,
            socialSecurity:0,
            monthRefund:0,
            reward:0,
            validAmount:0,
            deduction:0,
            performanceAmount:0,
            notReachAmount:0,
            refundCommission:0,
            actualCommission:0, 
        };
        this.$message.error(error)
      });


    },
    seachRest1(){
      let data = {  teacherName: this.formState.teacherName ? this.formState.teacherName : '', salaryYear: this.formState.salaryYear ? this.formState.salaryYear : '',  salaryMonth: this.formState.salaryMonth ? this.formState.salaryMonth : '', }
      axios.post(`${apiBaseUrl}//salary/exportTeacherSalary`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
             const downloadLink = document.createElement("a");
             downloadLink.href = URL.createObjectURL(blob);
             downloadLink.download = "薪酬模板.xlsx";
             downloadLink.click();
             this.$message.success('导出成功')
         }
         else{
            this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
         }
      })
    },

    countBottom(){
      let data = { 
        salaryYear: this.formState.salaryYear,     //年 yyyy格式
        salaryMonth: this.formState.salaryMonth,       //月 MM格式 
      }
      axios.post(`${apiBaseUrl}/salaryPlan/salaryIssue`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             this.$message.success('发放成功')
         }else{
            this.$message.error("发放失败!");
         }
      }).catch((error) => {
        this.$message.error(error)
      })
    },

    editInfo1Coot(row){
      axios.get(`${apiBaseUrl}/salaryPlan/salaryAnew?id=${row.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}) .then((res) => {
        if (res.data.code == 200) {
           this.$message.success(res.data.message)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },


    editInfo1(row, val){
        this.DetailsRow = row
        this.ShowCourseSalesStatisticsDetails = true
    },
    editInfo (row, val) {
      // this.isShowDialog = false
      if (val == "查看") {
        this.editOrview = false
      } else {
        this.editOrview = true
      }
      console.log(row);
      this.isShowDialog = true
      this.parentTeacherId = row.id
      // this.$refs.salaryMoudel.openDialogChild()

    },
    seachClear () {
      this.formState = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
        basicClassNum: "",
      }
      this.getList()
    },
    seachRest () {
      console.log(this.formState);
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.formState.pageSize = pageSize;
      this.getList();
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.formState.pageNum = newPage;
      this.getList();
    },
    isShowBtn () {
      this.isShowDialog = false
    },
  }

};
</script>

<style scoped lang="less">
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}


// ::v-deep.el-form-item__label {
//   text-align: right;
//   vertical-align: middle;
//   float: left;
//   font-size: 14px;
//   color: #606266;
//   line-height: 40px;
//   padding: 0 5px 0 0 !important;
//   box-sizing: border-box;
// }


/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  // #aa>>>.el-dialog {
  //   width: 70% !important;
  // }
}
 .btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/  .is-leaf{
  text-align: center !important;
}

/deep/ .el-table__cell{
    text-align: center !important;
}

</style>



// WEBPACK FOOTER //
// src/SalescompensationAll/Onlinesalescompensation.vue